/**
 * h5全局模块
 * 每个页面必须引入
 * jockey分享目前没有加入
 * 因为详情页逻辑不同
 */
// 图片时间戳
window._qiwa.sys_global.assetTs = '1';

// 引入jockey依赖
// tower 默认依赖 jockey
window.tower = require('@souche-f2e/tower');

// 清除运营商的植入广告
require('./lib/fuck_ad.js');
// 引入全局 jquery 插件
require('./lib/jquery.cookie.js');

// 同步官网用户
require('./lib/flushUserTag');

// 清除初始化背景颜色
(function () {
	$('.var-bg').removeClass('var-bg');
})();

// 图片懒加载
require('./lib/lazyload.js');
(function () {
	$('[data-original]').lazyload({
		effect : "fadeIn",
		threshold : 200
	});
})();

$('a[qiwa-href-news]').each(function (i, e) {
	var $this = $(e);
	var that = $this[0];
	$this.attr('href', that.href + '#news_' + ~~(Math.random()*1000))
});

// 初始化底部菜单
require('./lib/menu_module.js');

// 微信分享
require('./lib/share_wx.js');

// 20160320 临时解决方案
var img_url = require('../img-util/url-util.js');
(function () {
	var $img = $('img').eq(0);
	var url;
	if ($img.attr('src').length > 150
		&& window._qiwa && window._qiwa.__site_basic && window._qiwa.__site_basic.h5Logo) {
		$img.attr('src', img_url._formatUrl_v3(window._qiwa.__site_basic.h5Logo, '@300w_300h_4e_1wh.jpg'));
	}
})();

/**
 * 分享打点
 */
// var b_track = require('@souche-f2e/chunyan-util/qiwa-track/b.track.js');
// 暂时不能使用 npm 管理，因为部分依赖的页面还在 bds
var b_track = require('../qiwa-track/b.track.js');
window.Jockey.on('shareResultBridge', function(payload, complete) {
    /*
     *  payload
     *
     *  {
     *      result: true    //分享成功
     *      result: false   //分享失败
     *  }
     */
    b_track.share(function () {});
});

// app分享
var jockeyShare = require('./lib/share-jockey.js');
jockeyShare.init();

module.exports = {
	jockey: jockeyShare
};



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/common_m.js
// module id = 274
// module chunks = 4